<script setup lang="ts">
import { omit } from 'radash'
import { TooltipRoot, type TooltipRootEmits, type TooltipRootProps, useForwardPropsEmits } from 'radix-vue'

const props = defineProps<TooltipRootProps & { openOnClick?: boolean }>()
const emits = defineEmits<TooltipRootEmits>()

const forwarded = useForwardPropsEmits(() => omit(props, ['openOnClick']), emits)
const isOpen = ref(false)

const openTooltip = () => { // workaround for https://github.com/unovue/radix-vue/issues/1443
  if (!isOpen.value)
    isOpen.value = !isOpen.value
}
</script>

<template>
  <TooltipRoot
    v-bind="forwarded"
    v-model:open="isOpen"
    :disable-closing-trigger="openOnClick || disableClosingTrigger"
  >
    <span
      v-if="openOnClick"
      class="inline-flex items-center leading-none"
      @click="openTooltip"
    >
      <slot />
    </span>
    <slot v-else />
  </TooltipRoot>
</template>
